import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {NavigationItem} from '../model/navigation-item.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private http: HttpClient) {
  }

  getNavigationData(): Observable<NavigationItem[]> {
    return this.http.get('assets/data/navigation-config.json')
      .pipe(map((jsonData) => NavigationItem.fromJson(jsonData)));
  }
  
}
